import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../core/auth/auth.service';
import {FormsModule, ReactiveFormsModule, FormGroup, FormControl} from '@angular/forms';
import {RequestsService} from '../../../core/requests/requests.service';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  TextareaFieldComponent,
  TextFieldComponent
} from '@q9elements/ui-kit/components';
import {BaseDialogComponent, getFullName} from '@q9elements/ui-kit/common';
import {Q9Validators} from '@q9elements/ui-kit/validators';
import {from} from 'rxjs';

const MAX_DESCRIPTION_SIZE = 5000;

@Component({
  selector: 'app-changelog-popup',
  templateUrl: './changelog-popup.component.html',
  styleUrls: ['./changelog-popup.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    TranslateModule,
    DialogCloseButtonComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    TextFieldComponent,
    TextareaFieldComponent
  ],
  providers: [DatePipe]
})
export class ChangelogPopupComponent extends BaseDialogComponent implements OnInit {
  public form: FormGroup;
  public diagramId: string;

  constructor(
    private authSvc: AuthService,
    private requestSvc: RequestsService,
    protected dialogRef: MatDialogRef<ChangelogPopupComponent>,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private datePipe: DatePipe
  ) {
    super();
  }

  get task() {
    return {
      isApi: true,
      method: 'PUT',
      url: `/diagram/${this.diagramId}/state/draft/log`,
      data: this.requestPayload
    };
  }

  get requestPayload() {
    return {
      description: this.form.get('description').value,
      manual: true
    };
  }

  ngOnInit() {
    this.diagramId = this.diagramJsonSvc.get().diagramId;
    this.setForm();
  }

  public onSubmit() {
    if (this.form.invalid || this.isSubmitted) {
      return;
    }

    super.onSubmit();
  }

  protected sendSubmitRequest() {
    return from(
      this.requestSvc.addToQueue(this.task, true).then(() => {
        this.dialogRef.close(true);
      })
    );
  }

  private setForm() {
    const currTime = new Date();
    const author = getFullName(this.authSvc.getUserDataSync());

    this.form = new FormGroup({
      manualRecord: new FormControl({
        value: this.datePipe.transform(currTime, 'dd MMM, yyyy, h:mm aa (UTCZ)'),
        disabled: true
      }),
      author: new FormControl({value: author, disabled: true}),
      description: new FormControl('', [Q9Validators.maxLength(MAX_DESCRIPTION_SIZE)])
    });
  }
}
